/**
 * Normaliza un IBAN eliminando espacios y convirtiéndolo a mayúsculas.
 */
export function normalizeIban(value) {
	if (!value) return "";
	return String(value).replace(/\s+/g, "").toUpperCase();
}

/**
 * Formatea un IBAN para mostrarlo con espacios cada 4 caracteres.
 */
export function formatIban(value) {
	const normalized = normalizeIban(value);
	if (!normalized) return "";
	return normalized.replace(/(.{4})/g, "$1 ").trim();
}

/**
 * Valida un IBAN usando el algoritmo mod-97 (ISO 13616).
 */
export function isValidIban(value) {
	const iban = normalizeIban(value);
	if (!iban) return false;

	if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]+$/.test(iban)) return false;
	if (iban.length < 15 || iban.length > 34) return false;

	const rearranged = iban.slice(4) + iban.slice(0, 4);
	const numeric = rearranged.replace(/[A-Z]/g, (char) =>
		String(char.charCodeAt(0) - 55)
	);

	let remainder = numeric;
	while (remainder.length > 2) {
		const block = remainder.slice(0, 9);
		remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
	}

	return parseInt(remainder, 10) % 97 === 1;
}
